import React, {useState, useCallback} from "react";

import SimpleBar from "simplebar-react";
import {useAuth} from "../../../providers/AuthProvider";

import imgProfileTmp from 'modernize-essentials/dist/images/profile/user-1.jpg';
import {Link} from "react-router-dom";


function HeaderProfile(props) {
    const authContext = useAuth();
    const userData = authContext.user;

    let imgProfile = imgProfileTmp;
    if (userData.avatar) {
        imgProfile = userData.avatar;
    }


    const getLabelByRole = (type) => {
        let label = 'Без ролі';
        switch (type) {
            case 'admin': label = 'Адміністратор'; break;
        }

        return label;
    }


    return (<>
        <a className="nav-link" href="#" id="drop1" data-bs-toggle="dropdown" aria-expanded="false">
            <div className="d-flex align-items-center">
                <div className="user-profile-img d-flex">
                    <img src={imgProfile} className="rounded-circle" width="35" height="35" alt=""/>
                </div>
            </div>
        </a>
        <div className="dropdown-menu content-dd dropdown-menu-end dropdown-menu-animate-up" aria-labelledby="drop1">
            <SimpleBar autoHide={true} className={'profile-dropdown position-relative'}>
                <div className="py-3 px-7 pb-0">
                    <h5 className="mb-0 fs-5 fw-semibold">Ваш профіль</h5>
                </div>
                <div className="d-flex align-items-center py-9 mx-7 border-bottom">
                    <img src={imgProfile} className="rounded-circle" width="80" height="80" alt=""/>
                    <div className="ms-3">
                        <h5 className="fs-4 mb-2">{userData.name}</h5>
                        <span className="mb-0 d-block text-dark">{getLabelByRole(userData.type)}</span>
                        <p className="mb-0 d-flex text-dark align-items-center">
                            {userData.email}
                        </p>
                    </div>
                </div>
                <div className="message-body">
                    <Link to={'/categories'} reloadDocument className="py-8 px-7 mt-8 d-flex align-items-center">
                        <span className="d-flex align-items-center justify-content-center bg-light rounded-1 p-6">
                            <i className={'ti ti-list-tree fs-6'}></i>
                        </span>
                        <div className="w-75 d-inline-block v-middle ps-3">
                            <h6 className="mb-0 bg-hover-primary fw-semibold"> Мої категорії</h6>
                        </div>
                    </Link>
                    <Link to={'/rules'} reloadDocument className="py-8 px-7 d-flex align-items-center">
                        <span className="d-flex align-items-center justify-content-center bg-light rounded-1 p-6">
                            <i className={'ti ti-bolt fs-6'}></i>
                        </span>
                        <div className="w-75 d-inline-block v-middle ps-3">
                            <h6 className="mb-0 bg-hover-primary fw-semibold"> Правила обробки</h6>
                        </div>
                    </Link>
                    <Link to={'/tags'} reloadDocument className="py-8 px-7 d-flex align-items-center">
                        <span className="d-flex align-items-center justify-content-center bg-light rounded-1 p-6">
                            <i className={'ti ti-tags fs-6'}></i>
                        </span>
                        <div className="w-75 d-inline-block v-middle ps-3">
                            <h6 className="mb-0 bg-hover-primary fw-semibold"> Теги до транзакцій</h6>
                        </div>
                    </Link>
                    <Link to={'/settings/connected-accounts'} reloadDocument className="py-8 px-7 d-flex align-items-center">
                        <span className="d-flex align-items-center justify-content-center bg-light rounded-1 p-6">
                            <i className={'ti ti-users fs-6'}></i>
                        </span>
                        <div className="w-75 d-inline-block v-middle ps-3">
                            <h6 className="mb-0 bg-hover-primary fw-semibold"> Користувачі</h6>
                        </div>
                    </Link>
                    <Link to={'/settings/connected-accounts'} reloadDocument className="py-8 px-7 d-flex align-items-center">
                        <span className="d-flex align-items-center justify-content-center bg-light rounded-1 p-6">
                            <i className={'ti ti-settings fs-6'}></i>
                        </span>
                        <div className="w-75 d-inline-block v-middle ps-3">
                            <h6 className="mb-0 bg-hover-primary fw-semibold"> Налаштування</h6>
                        </div>
                    </Link>
                </div>
                <div className="d-grid py-4 px-7 pt-8">
                    <a href="/auth/logout" className="btn btn-outline-primary">Завершити сеанс</a>
                </div>
            </SimpleBar>
        </div>
    </>)
}

export default HeaderProfile;